exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card {\n  margin: 20px; }\n\n.example-container {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column; }\n\n.search_input {\n  height: 40px;\n  padding: 1rem;\n  background: #ededed; }\n\n.group_body {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column; }\n  .group_body .name_field.notAllowed {\n    cursor: not-allowed; }\n  .group_body .nodeForm {\n    display: contents; }\n\n.mat-dialog-container {\n  width: 210.3% !important; }\n\n.field_lock {\n  cursor: not-allowed; }\n\n.cdk-overlay-pane {\n  width: 553.5px !important; }\n\n.button-group {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-pack: start;\n      justify-content: flex-start; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/vincularAspectoPontoAcesso/vincularAspectoPontoAcesso.component.scss
// module id = ../../../../../src/app/components/vincularAspectoPontoAcesso/vincularAspectoPontoAcesso.component.scss
// module chunks = main